<!-- <ngx-spinner bdColor="rgb(63,69,95)" size="medium" color="#0af0d5" type="ball-scale-pulse" [fullScreen]="true"
class="d-flext justify-content-center align-items-center mb-5">
  <p style="color: white"> </p> -->
<!-- <img src="../.././assets/logo.png" alt="" srcset="" class="img-fluid  " style="margin-bottom: 120px;"> -->
<!-- </ngx-spinner> -->

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen] = "true"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
